import { UNIFIED_EVENT } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useLogicGroupRefinement } from '../../hooks/useLogicGroupRefinement';
import EditorConditionValueInput from './EditorConditionValueInput';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Select } from 'foundations-components/transitional/components/Select';
import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorUnifiedEventRefinement = ({
  field,
  onRefinementChange,
  refinement,
  inputUse
}) => {
  const {
    isChecked,
    onCheckboxChange,
    onRefinementConditionValueChange,
    onSelectedOptionChange,
    operatorName,
    operatorOptions,
    refinementCondition
  } = useLogicGroupRefinement(field, UNIFIED_EVENT, onRefinementChange, refinement);
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "300",
    as: "div",
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: isChecked,
      onChange: onCheckboxChange,
      children: field.label
    }), /*#__PURE__*/_jsxs(View, {
      marginInlineStart: "600",
      marginBlockStart: "200",
      as: "div",
      children: [/*#__PURE__*/_jsx(Select, {
        disabled: !isChecked,
        onSelectedOptionChange: onSelectedOptionChange,
        optionRenderer: option => /*#__PURE__*/_jsx(TypeaheadResultsItem, {
          message: true,
          option: option
        }),
        options: operatorOptions,
        readOnly: operatorOptions.length === 1,
        value: operatorName,
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          inputUse: inputUse,
          condition: refinementCondition,
          disabled: !isChecked,
          filterFamily: UNIFIED_EVENT,
          onChange: onRefinementConditionValueChange
        })
      })]
    })]
  });
};
export default EditorUnifiedEventRefinement;